// `/new` is the browser-only convenience route: the app always provisions a
// fresh Source and redirects to that Source's inspect path
// (console.hookdeck.com/{id}). Programmatic callers use POST / instead. See
// clients/apps/console/README.md ("GET /new").
//
// Pure helpers so the routing logic is unit-testable; the create + redirect
// side-effects live in ConsoleResourceContext.

/** Whether a path is the `/new` convenience-create route. */
export function isNewSourcePath(pathname: string): boolean {
  return pathname.replace(/\/+$/, '') === '/new';
}

/** The console inspect path for a Source id (with the `src_` prefix stripped). */
export function inspectPathForSourceId(source_id: string): string {
  return `/${source_id.replace(/^src_/, '')}`;
}
